import { __decorate, __metadata } from 'tslib';
import { Input, HostBinding, HostListener, Directive, ElementRef, Renderer2, ChangeDetectorRef, NgModule } from '@angular/core';

var nextUniqueId = 0;
var UkTooltipDirective = /** @class */ (function () {
    function UkTooltipDirective(element, renderer, cdr) {
        this.element = element;
        this.renderer = renderer;
        this.cdr = cdr;
        this._position = 'bottom';
        this._bgColor = 'black';
        this._isActive = false;
        this._margin = 14;
        this.class = true;
        this.tooltipID = "tooltip-" + nextUniqueId++;
        this.createTooltip();
    }
    Object.defineProperty(UkTooltipDirective.prototype, "ukTooltip", {
        get: function () { return this._text; },
        set: function (value) {
            this._text = value;
            if (this.tooltip.firstChild) {
                this.renderer.removeChild(this.tooltip, this.tooltip.firstChild);
            }
            this.renderer.appendChild(this.tooltip, this.renderer.createText(this._text));
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UkTooltipDirective.prototype, "ukTooltipPosition", {
        get: function () { return this._position; },
        set: function (value) {
            if (value !== this._position) {
                this.renderer.removeClass(this.tooltip, this._position);
                this._position = value;
                this.renderer.addClass(this.tooltip, this._position);
            }
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UkTooltipDirective.prototype, "ukTooltipBackground", {
        get: function () { return this._bgColor; },
        set: function (value) {
            if (value !== this._bgColor) {
                this.renderer.removeClass(this.tooltip, this._bgColor);
                this._bgColor = value;
                this.renderer.addClass(this.tooltip, this._bgColor);
                if (value === 'white') { // Tooltip for UkFormField
                    this._margin = 20;
                    this.renderer.addClass(this.tooltip, 'uk-shadow-2');
                }
            }
        },
        enumerable: true,
        configurable: true
    });
    UkTooltipDirective.prototype.onTouch = function (event) {
        this.show();
        event.preventDefault();
    };
    UkTooltipDirective.prototype.onClick = function () { this.show(); };
    UkTooltipDirective.prototype.onEnter = function () { this.show(); };
    UkTooltipDirective.prototype.onLeave = function () {
        clearTimeout(this.delayLongpress);
        this.hide();
    };
    UkTooltipDirective.prototype.oMouseDown = function () {
        var _this = this;
        this.delayLongpress = setTimeout(function () { _this.show(); }, 1300);
    };
    UkTooltipDirective.prototype.onMouseUp = function () {
        this.hide();
        clearTimeout(this.delayLongpress);
    };
    UkTooltipDirective.prototype.ngOnDestroy = function () {
        if (this._isActive) {
            clearTimeout(this.hideTimer);
        }
        this.renderer.removeChild(document.body, this.tooltip);
    };
    UkTooltipDirective.prototype.createTooltip = function () {
        this.tooltip = this.renderer.createElement('div');
        this.renderer.addClass(this.tooltip, 'uk-tooltip');
        this.renderer.addClass(this.tooltip, this._position);
        this.renderer.addClass(this.tooltip, 'sr-only');
        this.renderer.setAttribute(this.tooltip, 'role', 'tooltip');
        this.renderer.setAttribute(this.tooltip, 'id', this.tooltipID);
        this.renderer.appendChild(document.body, this.tooltip);
    };
    UkTooltipDirective.prototype.show = function () {
        var _this = this;
        this._isActive = true;
        this.renderer.removeClass(this.tooltip, 'sr-only');
        this.renderer.setAttribute(this.tooltip, 'aria-hidden', 'false');
        var position = this.getPosition();
        this.renderer.setStyle(this.tooltip, 'top', position.top + 'px');
        this.renderer.setStyle(this.tooltip, 'left', position.left + 'px');
        // Add timeout to close tooltip
        this.hideTimer = setTimeout(function () { _this.hide(); }, 5000);
        this.cdr.detectChanges();
    };
    UkTooltipDirective.prototype.hide = function () {
        if (this._isActive) {
            clearTimeout(this.hideTimer);
            this.renderer.setAttribute(this.tooltip, 'aria-hidden', 'true');
            this.renderer.addClass(this.tooltip, 'sr-only');
            this._isActive = false;
            this.cdr.detectChanges();
        }
    };
    UkTooltipDirective.prototype.getPosition = function () {
        var viewportOffset = this.element.nativeElement.getBoundingClientRect();
        var x = viewportOffset.x - (this.ukTooltipBackground === 'white' ? (viewportOffset.width / 3) : 0);
        var y = viewportOffset.y;
        // tslint:disable: curly
        // Avoid missing tooltips by wrong positioning.
        if (y < 100)
            this.ukTooltipPosition = 'bottom';
        if (y > window.innerHeight - 160)
            this.ukTooltipPosition = 'top';
        switch (this.ukTooltipPosition) {
            case 'bottom':
                y = y + this.element.nativeElement.offsetHeight + this._margin;
                break;
            case 'top':
                y = y - this.tooltip.offsetHeight - this._margin;
                break;
            case 'right':
                x = x + this.element.nativeElement.offsetWidth + this._margin;
                break;
            case 'left':
                x = x - this.tooltip.offsetWidth - this._margin;
                break;
        }
        return { left: x, top: y };
    };
    __decorate([
        Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], UkTooltipDirective.prototype, "ukTooltip", null);
    __decorate([
        Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], UkTooltipDirective.prototype, "ukTooltipPosition", null);
    __decorate([
        Input(),
        __metadata("design:type", String),
        __metadata("design:paramtypes", [String])
    ], UkTooltipDirective.prototype, "ukTooltipBackground", null);
    __decorate([
        HostBinding('attr.aria-describedby'),
        __metadata("design:type", String)
    ], UkTooltipDirective.prototype, "tooltipID", void 0);
    __decorate([
        HostBinding('class.uk-tooltip-host'),
        __metadata("design:type", Object)
    ], UkTooltipDirective.prototype, "class", void 0);
    __decorate([
        HostListener('touchstart', ['$event']),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], UkTooltipDirective.prototype, "onTouch", null);
    __decorate([
        HostListener('click'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], UkTooltipDirective.prototype, "onClick", null);
    __decorate([
        HostListener('mouseover'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], UkTooltipDirective.prototype, "onEnter", null);
    __decorate([
        HostListener('mouseout'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], UkTooltipDirective.prototype, "onLeave", null);
    __decorate([
        HostListener('mousedown'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], UkTooltipDirective.prototype, "oMouseDown", null);
    __decorate([
        HostListener('mouseup'),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], UkTooltipDirective.prototype, "onMouseUp", null);
    UkTooltipDirective = __decorate([
        Directive({
            selector: '[ukTooltip]'
        }),
        __metadata("design:paramtypes", [ElementRef,
            Renderer2,
            ChangeDetectorRef])
    ], UkTooltipDirective);
    return UkTooltipDirective;
}());

var UIKitTooltipModule = /** @class */ (function () {
    function UIKitTooltipModule() {
    }
    UIKitTooltipModule = __decorate([
        NgModule({
            declarations: [
                UkTooltipDirective
            ],
            exports: [
                UkTooltipDirective
            ]
        })
    ], UIKitTooltipModule);
    return UIKitTooltipModule;
}());

export { UIKitTooltipModule, UkTooltipDirective as ɵa };
//# sourceMappingURL=uikit-components-uk-tooltip.js.map
